var _rect, _rect2, _rect3, _rect4, _rect5, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoBlendXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 179,
    height: 179,
    rx: 9.5,
    fill: "#252525",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5068,
    y: 109.818,
    width: 23.7041,
    height: 38.1275,
    rx: 5,
    fill: "#94B67E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3699,
    y: 78.3208,
    width: 23.7041,
    height: 69.6242,
    rx: 5,
    fill: "#94B67E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.9263,
    y: 88.2676,
    width: 23.7041,
    height: 59.6779,
    rx: 5,
    fill: "#94B67E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 129.789,
    y: 58.4282,
    width: 23.7041,
    height: 89.5168,
    rx: 5,
    fill: "#94B67E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5916 79.15L68.8354 55.1131M78.9943 52.6265L103.545 62.5728M112.857 60.0862L136.561 39.3647",
    stroke: "#94B67E",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8192,
    cy: 82.4651,
    rx: 9.31233,
    ry: 9.11746,
    fill: "#94B67E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.0687,
    cy: 50.9685,
    rx: 9.31233,
    ry: 9.11746,
    fill: "#94B67E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.625,
    cy: 64.2302,
    rx: 9.31233,
    ry: 9.11746,
    fill: "#94B67E"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.488,
    cy: 34.3914,
    rx: 9.31233,
    ry: 9.11746,
    fill: "#94B67E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoBlendXLogo);
export default __webpack_public_path__ + "static/media/CryptoBlendXLogo.25559a0e3f6e6be64bd3f75f8f30b5be.svg";
export { ForwardRef as ReactComponent };